import { createFileRoute } from '@tanstack/react-router'
import { UserProfile } from '../../../features/admin/UserProfile'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/settings/profile')({
  component: UserProfileRoute,
})

/* ───── Route Component ───── */

function UserProfileRoute() {
  return <UserProfile />
}
